import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';

import { LayoutService } from '../../services/layout.service';
import { ToasterService } from 'src/app/shared/services/toaster.service';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import { AuthenticationService } from 'src/app/authentication/services/authentication.service';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { StaffsService } from 'src/app/organization/services/staffs.service';
import { SharedService } from 'src/app/shared/services/shared.service';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import { notificationResponseModel } from 'src/app/authentication/models/user-group';
import { ConfirmService } from 'src/app/shared/services/confirm.service';
import { MenuItem } from 'primeng/api';
import { OverlayPanel } from 'primeng/overlaypanel';

@Component({
  selector: 'app-right-menu',
  templateUrl: './right-menu.component.html'
})
export class RightMenuComponent extends BaseComponent implements OnInit {
  @ViewChild('option') option!: OverlayPanel;
  current_page = this.shared_service.getPage();
  items_per_page = this.shared_service.getLimit();
  notification_list: any[] = [];
  notification_count: number;
  unread_count: number;
  count: number;
  notification_id: string
  total_pages: number;

  constructor(
    public layoutService: LayoutService,
    private spinnerService: SpinnerService,
    private authenticationService: AuthenticationService,
    private confirm_service: ConfirmService,
    public translation_service: TranslationService,
    private toaster_service: ToasterService,
    public staffs_service: StaffsService,
    public shared_service: SharedService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.loadNotificationsList();
    //this.loadNotificaionCount();
  }

  loadNotificationsList() {
    if (this.current_page > this.total_pages) {
      return;
    }
    this.authenticationService.getNotificationsList(this.current_page, this.items_per_page).subscribe({
      next: (response: notificationResponseModel) => {
        if (response.result == 1) {
          const notifications = response.data.notification_list.map((item: any) => {
            const notificationDate = new Date(item.created_at);
            const formattedDate = this.shared_service.formatNotificationDate(notificationDate);
            return {
              ...item,
              profile_image: item.profile_image ? this.shared_service.getHostUrl() + item.profile_image : this.shared_service.getDefaultImage(),
              formatted_date: formattedDate,
              group_date: notificationDate
            };
          });
          let notifi = this.shared_service.groupNotificationsByDate(notifications);
          this.notification_list = [...this.notification_list, ...notifi];
          this.total_pages = Math.ceil(response.count / this.items_per_page);
          this.unread_count = response.data.un_read_count;
          this.count = response.count;
        }
        else if (response.result == 0) {
          this.toaster_service.showError(response.error.message[0])
        } else {
          this.toaster_service.showError(response.stackTrace);
        }
      },
      error: (error: any) => {
        this.toaster_service.showError(error);
      },
      complete: () => { }
    });
  }

  onScroll() {
    if (this.current_page < this.total_pages) {
      this.current_page++;
      this.loadNotificationsList();
    }
  }

  loadNotificationCount() {
    this.authenticationService.getNotificationCount().subscribe({
      next: (response: any) => {
        if (response.result == 1) {
          this.notification_count = response.data;
        } else if (response.result == 0) {
          this.toaster_service.showError(response.error.message[0])
        } else {
          this.toaster_service.showError(response.stackTrace);
        }
      },
      error: (error: any) => {
        this.spinnerService.hide();
        this.toaster_service.showError(error, true);
      },
      complete: () => {
        this.spinnerService.hide();
      }
    })
  }

  notificationRead(notification_id: any, isRead: boolean) {
    const data = {
      is_read: isRead
    };
    this.authenticationService.readNotification(notification_id, data).subscribe({
      next: (response: any) => {
        if (response.result === 1) {
          const message = isRead ? this.translation_service.getText('message_374') : this.translation_service.getText('message_375');
          this.toaster_service.showSuccess(message);
          this.clearList();
          this.loadNotificationsList();
          this.authenticationService.triggerTabUpdate();
        } else if (response.result == 0) {
          this.toaster_service.showError(response.error.message[0])
        } else {
          this.toaster_service.showError(response.stackTrace);
        }
      },
      error: (error: any) => {
        this.toaster_service.showError(error.message);
      },
      complete: () => { }
    });
  }

  clearList() {
    this.notification_list = [];
    this.current_page = this.shared_service.getPage();
  }

  notificationReadAll() {
    this.confirm_service.showConfirmation(this.translation_service.getText('message_376')).then((result) => {
      if (result) {
        const data = {
          is_read: true
        }
        this.authenticationService.readAllNotification(data).subscribe({
          next: (response: any) => {
            if (response.result == 1) {
              this.toaster_service.showSuccess(this.translation_service.getText('message_377'));
              this.clearList();
              this.loadNotificationsList();
              this.authenticationService.triggerTabUpdate();
            } else if (response.result == 0) {
              this.toaster_service.showError(response.error.message[0])
            } else {
              this.toaster_service.showError(response.stackTrace);
            }
          },
          error: (error: any) => {
            this.toaster_service.showError(error.message);
          },
          complete: () => { }
        });
      }
    });
  }

  notificationUnreadAll() {
    this.confirm_service.showConfirmation(this.translation_service.getText('message_378')).then((result) => {
      if (result) {
        const data = {
          is_read: false
        }
        this.authenticationService.unreadAllNotification(data).subscribe({
          next: (response: any) => {
            if (response.result == 1) {
              this.toaster_service.showSuccess(this.translation_service.getText('message_379'));
              this.clearList();
              this.loadNotificationsList();
              this.authenticationService.triggerTabUpdate();
            } else if (response.result == 0) {
              this.toaster_service.showError(response.error.message[0])
            } else {
              this.toaster_service.showError(response.stackTrace);
            }
          },
          error: (error: any) => {
            this.toaster_service.showError(error.message);
          },
          complete: () => { }
        });
      }
    });
  }


  notificationDelete(event: Event, notification_id: any) {
    this.confirm_service.showConfirmation(this.translation_service.getText('message_380')).then((result) => {
      if (result) {
        const data = {
          is_deleted: true
        }
        this.authenticationService.deleteNotification(notification_id, data).subscribe({
          next: (response: any) => {
            if (response.result == 1) {
              this.toaster_service.showSuccess(this.translation_service.getText('message_381'));
              this.clearList();
              this.loadNotificationsList();
              this.authenticationService.triggerTabUpdate();
            } else if (response.result == 0) {
              this.toaster_service.showError(response.error.message[0])
            } else {
              this.toaster_service.showError(response.stackTrace);
            }
          },
          error: (error: any) => {
            this.toaster_service.showError(error.message);
          },
          complete: () => { }
        });
      }
    });
  }

  onDelete() {
    this.confirm_service.showConfirmation(this.translation_service.getText('message_382')).then((result) => {
      if (result) {
        const data = {
          is_deleted: true
        }
        this.authenticationService.deleteAllNotification(data).subscribe({
          next: (response: any) => {
            if (response.result == 1) {
              this.toaster_service.showSuccess(this.translation_service.getText('message_381'));
              this.clearList();
              this.loadNotificationsList();
              this.loadNotificationCount();
              this.authenticationService.triggerTabUpdate();
            } else if (response.result == 0) {
              this.toaster_service.showError(response.error.message[0])
            } else {
              this.toaster_service.showError(response.stackTrace);
            }
          },
          error: (error: any) => {
            this.toaster_service.showError(error.message);
          },
          complete: () => { }
        });
      }
    });
  }

  toggleOptions(event: Event, options: HTMLElement) {
    options.style.visibility = options.style.visibility === 'visible' ? 'hidden' : 'visible';
  }

  get rightMenuActive(): boolean {
    return this.layoutService.state.rightMenuActive;
  }

  set rightMenuActive(_val: boolean) {
    this.layoutService.state.rightMenuActive = _val;
  }

  close() {
    this.rightMenuActive = false;
    this.authenticationService.triggerTabUpdate();
  }

}